import { DialogData } from "@lib/titan2/dist/game/control/data/DialogData";
import { AbstractDialogController } from "@lib/titan2/dist/game/controller/AbstractDialogController";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { Renderer, ResizeEvent } from "@lib/titan2/dist/game/renderer/Renderer";
import { CommonLang } from "@lib/titan2/dist/game/view/lang/CommonLang";
import { KeyValuePair } from "@lib/titan2/dist/util/collection/KeyValuePair";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { Service } from "../../api/Service";
import { ArcadeWheelEvent, ArcadeWheelLang } from "../view/abstract/display/ArcadeWheel";
/**
 * DialogController.ts
 */
export class DialogController extends AbstractDialogController {
    create() {
        super.create();
    }
    postCreate() {
        super.postCreate();
        this.baseFactory = this.baseFactory;
        Logger.addObjectRef(this, "DialogController");
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
        this.renderer = Renderer.getInstance();
    }
    createProperties() {
        super.createProperties();
        this.landscapeProperties = this.dialogManager.getProperties();
        this.portraitProperties = this.dialogManager.getPortraitProperties();
        this.uiProperties = this.getCurrentProperties();
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(CommonGameEvent.INITIALISE, this.handleInitialise);
        this.registerGame(CommonGameEvent.HELP_OPEN, this.handleHelpOpen);
        this.registerGame(CommonGameEvent.STANDARD_SPIN_RECOVERY, this.handleRecovery);
        this.registerGame(CommonGameEvent.FREE_SPIN_RECOVERY, this.handleRecovery);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN_RECOVERY, this.handleRecovery);
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.handlePurchaseEntry);
        this.registerGame(ArcadeWheelEvent.OUT_OF_SPINS, this.handleArcadeWheelOutOfSpins);
        this.registerCore(ResizeEvent.ROTATE, this.handleRotate);
    }
    handleInitialise() {
        this.preload();
    }
    handleHelpOpen() {
        let landscapeProperties = this.landscapeProperties.helpDialogProperties;
        let portraitProperties = this.portraitProperties?.helpDialogProperties;
        this.dialogManager.open(landscapeProperties, portraitProperties);
    }
    handlePurchaseEntry() {
        if (this.model.hasFreeGameAvailable()) {
            this.handleFreeGameAvailable();
        }
    }
    handlePurchaseSpin() {
        if (this.model.isFreeGame()) {
            let progress = this.model.getGameProgress();
            if (progress.isFirstPurchasableSpin()) {
                if (this.model.getShowFreeGameWin()) {
                    if (this.model.getTotalWin() > 0) {
                        this.handleFreeGameWin();
                    }
                    else {
                        this.handleFreeGameNoWin();
                    }
                    this.model.setShowFreeGameWin(false);
                }
            }
        }
    }
    handleArcadeWheelOutOfSpins() {
        let data = new DialogData();
        data.addLang(CommonLang.DIALOG_TITLE, this.languageManager.getLang(CommonLang.STAKE_LIMITS_TITLE));
        data.addLang(CommonLang.DIALOG_MESSAGE, this.languageManager.getLang(ArcadeWheelLang.DIALOG_OUT_OF_SPINS));
        data.onConfirm(this.handleGameOverConfirmed, this);
        this.dialogManager.open(this.landscapeProperties.messageDialogProperties, this.portraitProperties?.messageDialogProperties, data);
    }
    handleFreeGameAvailable() {
        let params = [new KeyValuePair(CommonLang.PARAM_AMOUNT, this.model.getFreeGamesRemaining())];
        let data = new DialogData();
        data.addLang(CommonLang.DIALOG_TITLE, this.languageManager.getLang(CommonLang.FREE_GAME_AVAILABLE_TITLE));
        data.addLang(CommonLang.DIALOG_MESSAGE, this.languageManager.getLang(CommonLang.FREE_GAME_AVAILABLE_MESSAGE, params));
        this.dialogManager.open(this.landscapeProperties.messageDialogProperties, this.portraitProperties?.messageDialogProperties, data);
    }
    handleFreeGameWin() {
        let data = new DialogData();
        let params = [new KeyValuePair(CommonLang.PARAM_AMOUNT, this.formatCurrency(this.model.getTotalWin()))];
        data.addLang(CommonLang.DIALOG_TITLE, this.languageManager.getLang(CommonLang.FREE_GAME_COMPLETE_TITLE));
        data.addLang(CommonLang.DIALOG_MESSAGE, this.languageManager.getLang(CommonLang.FREE_GAME_COMPLETE_WIN_MESSAGE, params));
        this.dialogManager.open(this.landscapeProperties.messageDialogProperties, this.portraitProperties?.messageDialogProperties, data);
    }
    handleFreeGameNoWin() {
        let data = new DialogData();
        data.addLang(CommonLang.DIALOG_TITLE, this.languageManager.getLang(CommonLang.FREE_GAME_COMPLETE_TITLE));
        data.addLang(CommonLang.DIALOG_MESSAGE, this.languageManager.getLang(CommonLang.FREE_GAME_COMPLETE_CONTINUE_MESSAGE));
        this.dialogManager.open(this.landscapeProperties.messageDialogProperties, this.portraitProperties?.messageDialogProperties, data);
    }
    handleRotate(event) {
        const data = event?.getCurrentTarget() || {};
        this.uiProperties = this.getCurrentProperties(data.forceOrientation);
    }
    getCurrentProperties(forceOrientation) {
        let properties = this.landscapeProperties;
        if (this.portraitProperties && this.renderer.isPortrait(forceOrientation)) {
            properties = this.portraitProperties;
        }
        return properties;
    }
    openDialog(properties, data, refresh) {
        if (this.operatorConfig.isDialogEnabled() && !Service.isReplay()) {
            this.dialogManager.open(properties, undefined, data, refresh);
        }
    }
}
//# sourceMappingURL=DialogController.js.map